"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationProvider = void 0;
const react_1 = __importStar(require("react"));
const OrganizationContext_1 = require("./OrganizationContext");
const OrganizationProvider = ({ children, }) => {
    const [settingOrganization, setSettingOrganization] = (0, react_1.useState)(true);
    const [showOrgDrawer, setShowOrgDrawer] = (0, react_1.useState)(false);
    const [reactiveSelectedOrgUser, setReactiveSelectedOrgUser] = (0, react_1.useState)(undefined);
    const resetData = () => {
        setReactiveSelectedOrgUser(undefined);
    };
    const unSetSelectedOrgUser = (orgUser) => __awaiter(void 0, void 0, void 0, function* () {
        yield orgUser.switchOrganization();
    });
    const setSelectedOrgUser = (orgUser) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setSettingOrganization(true);
            if (orgUser)
                yield orgUser.initOrganization();
            setReactiveSelectedOrgUser(() => orgUser ? { selectedOrgUser: orgUser } : undefined);
        }
        finally {
            setSettingOrganization(false);
        }
    });
    (0, react_1.useEffect)(() => {
        let unsubscribeListener;
        if (reactiveSelectedOrgUser === null || reactiveSelectedOrgUser === void 0 ? void 0 : reactiveSelectedOrgUser.selectedOrgUser) {
            unsubscribeListener =
                reactiveSelectedOrgUser.selectedOrgUser.registerChangeListener((selectedOrgUser) => {
                    setReactiveSelectedOrgUser(() => ({
                        selectedOrgUser,
                    }));
                });
        }
        return () => {
            if (unsubscribeListener) {
                unsubscribeListener();
            }
        };
    }, [reactiveSelectedOrgUser === null || reactiveSelectedOrgUser === void 0 ? void 0 : reactiveSelectedOrgUser.selectedOrgUser]);
    return (react_1.default.createElement(OrganizationContext_1.OrganizationContext.Provider, { value: {
            setSelectedOrgUser,
            unSetSelectedOrgUser,
            selectedOrgUser: reactiveSelectedOrgUser === null || reactiveSelectedOrgUser === void 0 ? void 0 : reactiveSelectedOrgUser.selectedOrgUser,
            showOrgDrawer,
            setShowOrgDrawer,
            settingOrganization,
            resetData,
        } }, children));
};
exports.OrganizationProvider = OrganizationProvider;
